// helper which creates specific update logic
import startCase from 'lodash.startcase'
import isEqual from 'lodash.isequal'
import to from 'await-to-js'

import {
  addRequestAuthentication,
  invokeHooks,
  pascalCase,
  promisifyRPC
} from '../utils'

export default ({ actionType, name, config, common }) => {
  let fn = async (context, params) => {
    const { commit, state, dispatch } = context
    // 1) prepare request object
    // - convention: uppercase first letter of name + add 'Request'
    let requestObjectType = `${pascalCase(name)}Request`
    let request = new config.service.import[requestObjectType]()
    // - add authentication
    addRequestAuthentication(config, context, request, common.actionDefinitions[actionType][name].typeMappings)
    // - ALLOW HOOK to change something within the request or make a whole new request
    request = await invokeHooks(actionType, 'beforeDataRequest', name, { config, context, request, params })
    // if request is now null - some error happened!
    if (!request) {
      commit('finishedLatestRequest', name)
      return false
    }
    // 2) call API
    // save this request as the latest one (also sets error to null)
    commit('setLatestRequest', {
      name: name,
      masterActiveKey: state.masterActiveKey,
      request: request
    })
    // Invoke RPC and wait for it
    // - need to promisify GPRC call
    // - metadata is not used anywhere?
    let [err, data] = await to(promisifyRPC(config, name, request, context))
    // 3) GOT RESULTS
    // once we return here, we might not be processing the latest request anymore
    //  - we could have already switched MASTER ACTIVE ITEM as well and getting new items
    let isLastRequest = isEqual(request, state.latestRequests[name].request)
    if (err) {
      // push the error info into state, maybe we will show it to user
      dispatch('error', {
        message: `${startCase(name)}: Error while retrieving data.`,
        error: err
      })
      // we invoke the error handling but we don't know if this is processing the latest request
      await invokeHooks(actionType, 'error', name, { config, context, request, params, data: err })
      if (isLastRequest) {
        commit('setLatestRequestError', { name: name, error: err })
        commit('finishedLatestRequest', name)
      }
      return false
    }
    // extract items from the data object
    // we assume that everything is in place because no err happened
    let responseData = data.toObject()
    // store the whole response in the store
    if (isLastRequest) {
      commit('setLatestResponse', { name, responseData })
    }
    // whatever we get as response, take the first object and patch the state
    const updatedItem = responseData[Object.keys(responseData)[0]]
    commit('patchItem', updatedItem)
    // call hook if needed
    await invokeHooks(actionType, 'afterDataRequest', name, { config, context, request, params, data: responseData })
    // all done
    if (isLastRequest) {
      commit('finishedLatestRequest', name)
    }
    return true
  }
  return fn
}
